// extracted by mini-css-extract-plugin
export default {"gallery":"c-o_fm","gallery__header":"c-o_fn","gallery__thumbs":"c-o_fo"};